import { InteractionRequiredAuthError, PublicClientApplication, type AccountInfo } from '@azure/msal-browser';

/** Staff sign in with their MindHYVE Microsoft 365 account (Entra ID). */
const clientId = import.meta.env.VITE_ENTRA_SPA_CLIENT_ID as string | undefined;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string | undefined;
const scope = import.meta.env.VITE_ENTRA_API_SCOPE as string | undefined;

export const msalEnabled = Boolean(clientId && tenantId && scope);

export const msal = new PublicClientApplication({
  auth: {
    clientId: clientId ?? '00000000-0000-0000-0000-000000000000',
    authority: `https://login.microsoftonline.com/${tenantId ?? 'common'}`,
    redirectUri: `${window.location.origin}/console`,
    postLogoutRedirectUri: `${window.location.origin}/`,
  },
  cache: { cacheLocation: 'sessionStorage' },
});

export const msalReady = msal.initialize().then(() => msal.handleRedirectPromise()).then((r) => {
  if (r?.account) msal.setActiveAccount(r.account);
  else if (!msal.getActiveAccount() && msal.getAllAccounts()[0]) msal.setActiveAccount(msal.getAllAccounts()[0]!);
});

export const staffAccount = (): AccountInfo | null => msal.getActiveAccount();

export async function staffToken(): Promise<string> {
  await msalReady;
  const account = msal.getActiveAccount();
  if (!account) {
    await msal.loginRedirect({ scopes: [scope!] });
    throw new Error('redirecting');
  }
  try {
    return (await msal.acquireTokenSilent({ scopes: [scope!], account })).accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) await msal.acquireTokenRedirect({ scopes: [scope!], account });
    throw err;
  }
}

export const staffSignIn = () => msal.loginRedirect({ scopes: [scope!], prompt: 'select_account' });
export const staffSignOut = () => msal.logoutRedirect();
